class Mspeezfitness extends Array {}

const mspeezfitness_api_adapter = mspeezfitness => mspeezfitness;

const mspeezfitness_list_api_adapter = mspeezfitness =>
    mspeezfitness.map(mspeezfitness_api_adapter);

const createMspeezfitnessList = (data = []) => {
    const mspeezfitness = Mspeezfitness.from(data, mspeezfitness =>
        createMspeezfitness(mspeezfitness)
    );
    return mspeezfitness;
};

const mspeezfitness_view_adapter = mspeezfitness => {
    return mspeezfitness;
};

const createMspeezfitness = ({id = null, country = null, geom = null} = {}) => {
    const publicApi = {
        id,
        country,
        geom,
    };

    return Object.freeze(publicApi);
};

export {
    createMspeezfitness,
    createMspeezfitnessList,
    mspeezfitness_api_adapter,
    mspeezfitness_list_api_adapter,
    mspeezfitness_view_adapter,
};
